import { useDispatch } from 'react-redux'
import { memo } from 'react'
import { useI18n } from 'builder/hooks/useI18n'
import Icon24 from 'builder/components/Icon'
import { actions } from 'builder/modules/resumeEditor'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import { Button, ButtonContainer, ButtonText } from './styles'

type Props = {
  isCollapsed: boolean
}

export const FloatingCustomizationButton = memo((props: Props) => {
  const { isCollapsed } = props
  const { i18n } = useI18n()
  const dispatch = useDispatch()
  const { isAboveTablet } = useMediaQueries()

  const handleClick = () => {
    dispatch(actions.setIsCustomizeModalOpen(true))
  }

  return isAboveTablet ? (
    <ButtonContainer>
      <Button
        $isCollapsed={isCollapsed}
        onClick={handleClick}
        data-testid="floating-customization-button"
      >
        <ButtonText $isCollapsed={isCollapsed}>
          {i18n.t('builder.resume_editor.customization')}
        </ButtonText>
        <Icon24.Grid />
      </Button>
    </ButtonContainer>
  ) : null
})
